module.exports = __webpack_public_path__ + "img/sp.a9dd651c.png";